import _ from 'lodash'

export const getAllKB = (state) => _.get(state, 'kb.kbList', [])
export const getKB = (state) => _.get(state, 'kb.kb', {})
export const getKBSections = (state) => _.get(state, 'kb.kbSections', [])
export const getUpdatingState = (state) => _.get(state, 'kb.updating', false)
export const getModalState = (state) => _.get(state, 'kb.showModal', false)
export const getAddingState = (state) => _.get(state, 'kb.adding', false)
